import "../assets/Tooltip.css";
import { defineComponent as R, useCssVars as V, unref as r, ref as n, computed as _, openBlock as b, createBlock as z, Transition as L, withCtx as N, withDirectives as W, createElementVNode as w, normalizeStyle as X, createTextVNode as P, toDisplayString as Y, vShow as j } from "vue";
import { u as q } from "./index.72N0HVaZ.js";
import { e as o, o as A } from "./useStore.Cko4vubE.js";
const F = ["data-to-left"], g = 20, y = 10, u = 8, C = 10, M = /* @__PURE__ */ R({
  __name: "Tooltip",
  props: {
    autoHide: {},
    backColor: { default: "#88001e" },
    color: { default: "#ffffff" }
  },
  setup(S, { expose: T }) {
    V((e) => ({
      "2c31f66e": e.backColor,
      "199a9c15": e.color,
      "3eac2f2e": r(o)(y),
      "3eac2f6c": r(o)(g),
      "62944c42": r(o)(C),
      "62944a52": r(o)(u)
    }));
    const l = A(), f = S, s = n(), i = n(), c = n(!1), p = n(), a = n(), { width: k, height: x } = q(i), d = _(() => {
      if (a.value && (l != null && l.styles.rootElement)) {
        const {
          left: e,
          width: t
        } = l.styles.rootElement.getBoundingClientRect();
        return a.value.left > e + t / 2;
      }
      return !1;
    }), H = _(() => {
      if (a.value && i.value) {
        const {
          left: e,
          top: t
        } = a.value, h = C + u, B = x.value + y * 2 + u, D = k.value + g * 2;
        return {
          top: o(t - B),
          left: o(e - (d.value ? D - h : h))
        };
      }
      return {};
    });
    function v() {
      s.value && (clearTimeout(s.value), s.value = null);
    }
    function m() {
      v(), c.value = !1;
    }
    function E(e, t) {
      v(), c.value = !0, a.value = t, p.value = e, f.autoHide && (s.value = setTimeout(() => {
        m();
      }, f.autoHide));
    }
    return T({
      show: E,
      hide: m
    }), (e, t) => (b(), z(L, { name: "fade-tooltip" }, {
      default: N(() => [
        W(w("div", {
          class: "thn--tool-tooltip",
          ref_key: "rootRef",
          ref: i,
          style: X(H.value)
        }, [
          w("span", {
            class: "thn--tool-tooltip__arrow",
            "data-to-left": d.value
          }, null, 8, F),
          P(" " + Y(p.value), 1)
        ], 4), [
          [j, c.value]
        ])
      ]),
      _: 1
    }));
  }
});
export {
  M as _
};
//# sourceMappingURL=Tooltip.vue_vue_type_style_index_0_lang.B6NyKSE5.js.map
